import { FC, memo } from 'react';

import { parseISO } from 'date-fns';
import { noop } from 'utils/clickme';
import { VIEW_DATE_FORMAT } from 'utils/constants/date';
import { formatDate } from 'utils/date';

import IntervalCalendarPicker from 'bloko/blocks/calendar/IntervalCalendarPicker';
import DropDownClick, { DownPlacement } from 'bloko/blocks/drop/Down/Click';
import Icon, { IconScale, IconView } from 'bloko/blocks/icon';
import InputText from 'bloko/blocks/inputText';

import useTrls from 'hooks/translation/useTrls';

interface InputWithMultiDatePickerProps {
    from: Date;
    to: Date;
    action: (from: Date, to: Date) => void;
    dataQa?: string;
    closeAfterSelect?: boolean;
}

const InputWithMultiDatePicker: FC<InputWithMultiDatePickerProps> = ({
    from,
    to,
    action,
    dataQa,
    closeAfterSelect,
}) => {
    const trl = useTrls();

    return (
        <DropDownClick
            render={(closeDrop) => (
                <IntervalCalendarPicker
                    initialDate={formatDate(from)}
                    start={formatDate(from)}
                    end={formatDate(to)}
                    onDateClick={({ start, end }) => {
                        setTimeout(() => {
                            action(parseISO(start), parseISO(end));

                            if (closeAfterSelect) closeDrop?.();
                        }, 0);
                    }}
                    disablePartMonth={false}
                />
            )}
            placement={DownPlacement.BottomStart}
        >
            <InputText
                placeholder={trl('admin.actsReport.filter.input')}
                icon={<Icon view={IconView.Calendar} scale={IconScale.Small} />}
                value={`${formatDate(from, VIEW_DATE_FORMAT)} - ${formatDate(to, VIEW_DATE_FORMAT)}`}
                onChange={noop}
                size="30"
                data-qa={dataQa}
            />
        </DropDownClick>
    );
};

export default memo(InputWithMultiDatePicker);
